module.exports = __webpack_public_path__ + "7bcbd9a76b2fbe533d225de0e33c8153.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2089_teaser_image.jpg
// module id = 592
// module chunks = 0